/** @format */

import { Component, Inject, OnInit } from '@angular/core';
import { WINDOW } from '@shared/data-access/services';

@Component({
	selector: 'origin-root',
	templateUrl: './app.component.html',
	standalone: false
})
export class AppComponent implements OnInit {
	constructor(@Inject(WINDOW) protected window: Window) {}

	ngOnInit(): void {
		// Reset the analytics
		this.window.siteData = {};
		this.window.siteData.ErrorID = ['Site Down'];
		this.window.siteData.ErrorMessage = ["WE'RE SORRY"];
		this.window.siteData.EventData = [];
		this.window.siteData.PageName = 'Site Down';
	}
}
